<script setup lang="ts">
const items = [
  'Dari performa pengiriman hingga cashflow COD, Dashboard Member menjadi pusat kendali bisnis Anda.',
  'Didesain untuk pengambil keputusan: cepat, akurat, dan efisien.',
  'Karena setiap detik keterlambatan data berarti ada peluang yang hilang.'
]

const { isMobile } = useBreakpoints()
</script>

<template>
  <UiSectionWrapper
    image-class="order-first lg:order-first"
    title="Data Anda Tidak Seharusnya Tersebar di Banyak Sistem"
    description="Kini, semua bisa dipantau dalam satu Dashboard Member KiriminAja."
    hero-image="/images/dashboard-member-banner-2.webp"
    class="py-12"
  >
    <template #action>
      <div class="mt-6 lg:mt-12 flex flex-col gap-6 text-lg leading-7">
        <div
          v-for="(item, index) in items"
          :key="index"
          class="flex items-start gap-3"
        >
          <Icon
            class="text-primary flex-none"
            name="material-symbols:verified"
            :size="isMobile ? '22px' : '30px'"
          />
          <p class="text-sm lg:text-lg flex-1">
            {{ item }}
          </p>
        </div>
      </div>
    </template>
  </UiSectionWrapper>
</template>
